import { Col, Row } from "reactstrap";
import "./receipt.style.css";

/**
 * @typedef {Object} Props
 * @property {string} lineField
 * @property {string} lineValue
 * @property {string} [classStyles]
 */

/**
 * @function ReceiptLineItem
 * @param {Props} props
 * @type {React.JSX.Element}
 */
const ReceiptLineItem = ({ lineField, lineValue, classStyles }) => {
  let classNames = "";
  if (classStyles) {
    classNames += classStyles;
  }

  return (
    <Row className={classNames}>
      <Col sm="10" className="offset-sm-1 receiptColColor">
        <span className="receiptPrimaryColor">{lineField}: </span>
        <span style={{ color: "#000" }}>{lineValue}</span>
      </Col>
    </Row>
  );
};

export default ReceiptLineItem;
